import { observer } from 'mobx-react-lite'
import { Alert, Box, TextFieldWithLabel, Typography } from 'shared/ui'
import { formatPhoneNumberNational } from 'shared/lib'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { type EnterAddressStore } from 'pages/settings/ui/EnterAddressCommon/store/EnterAddressStore'
import styles from './styles.module.scss'

export const EnterAddressCommon = observer(
  ({ phone, enterAddressStore }: { phone: string; enterAddressStore: EnterAddressStore }) => {
    const {
      name,
      setName,
      streetAddress,
      setStreetAddress,
      city,
      setCity,
      state,
      states,
      setState,
      zip_code,
      setZipCode,
      nextDisabled,
      nextLoading,
      nextClickHandler,
      error,
      getErrorField,
    } = enterAddressStore

    return (
      <div className={styles.wrap}>
        <Typography
          tag={'div'}
          color='tertiary'
          variant='body-md-regular'
          ariaLabel='EnterNumberDescription'
          marginTop='16px'
        >
          Please enter the billing address that’s associated with your landline number{' '}
          {formatPhoneNumberNational(phone)}.
        </Typography>

        {error && (
          <Box marginTop={'20px'}>
            <Alert
              item={{
                type: 'error',
                desc: error,
              }}
            />
          </Box>
        )}

        <div>
          <TextFieldWithLabel
            marginTop={'40px'}
            labelProps={{
              label: {
                text: 'Name',
              },
            }}
            errorMessage={getErrorField('friendly_name')}
            textFieldProps={{
              onChange: setName,
              value: name,
              InputProps: {
                placeholder: 'e.g. John Brown',
              },
            }}
            limit={64}
          />

          <TextFieldWithLabel
            marginTop={'25px'}
            labelProps={{
              label: {
                text: 'Street address',
              },
            }}
            errorMessage={getErrorField('street')}
            textFieldProps={{
              onChange: setStreetAddress,
              value: streetAddress,
              InputProps: {
                placeholder: 'e.g. Acme Street',
              },
            }}
            limit={255}
          />

          <TextFieldWithLabel
            marginTop={'25px'}
            labelProps={{
              label: {
                text: 'City',
              },
            }}
            errorMessage={getErrorField('city')}
            textFieldProps={{
              onChange: setCity,
              value: city,
              InputProps: {
                placeholder: 'e.g. Los Angeles',
              },
            }}
            limit={255}
          />

          <Box display='flex' justifyContent='space-between' gap={'12px'} marginTop={'23px'}>
            <Box flex={1}>
              <SelectField
                items={states}
                setValue={setState}
                value={state}
                error={getErrorField('state')}
                btnProps={{
                  size: 'large',
                  style: {
                    height: '40px',
                  },
                }}
                selectProps={{
                  variant: 'stroke',
                  placeholder: 'e.g. California (CA)',
                  textFieldPlaceholderProps: {
                    className: styles.statePlaceholder,
                  },
                }}
                labelProps={{
                  label: {
                    text: 'State',
                  },
                }}
                dropdownProps={{
                  textFieldProps: {
                    InputProps: {
                      placeholder: 'e.g. California (CA)',
                    },
                  },
                }}
              />
            </Box>

            <Box flex={1}>
              <TextFieldWithLabel
                labelProps={{
                  label: {
                    text: 'ZIP Code',
                  },
                }}
                errorMessage={getErrorField('zip')}
                textFieldProps={{
                  onChange: setZipCode,
                  value: zip_code,
                  InputProps: {
                    placeholder: 'e.g. 90011',
                  },
                }}
              />
            </Box>
          </Box>
        </div>

        <NextButton
          text='Next'
          disabled={nextDisabled}
          loading={nextLoading}
          onClick={nextClickHandler}
        />
      </div>
    )
  }
)
